/* c8 ignore start */
import { PHISHING_SIMULATION } from "@/utils/services";

export const mspRoutes = {
  path: "/msp",
  component: () => import("@/layouts/Msp/MspLayout.vue"),
  children: [
    {
      path: "phishing_simulation",
      name: "msp-phishing_simulation",
      component: () =>
        import("@/modules/PhishingSimulations/views/Msp/msp.index.vue"),
      redirect: {
        name: "msp-phishing_simulation-overview",
      },
      meta: {
        solutionId: PHISHING_SIMULATION,
      },
      children: [
        {
          path: "overview",
          name: "msp-phishing_simulation-overview",
          component: () =>
            import(
              "@/modules/PhishingSimulations/views/Msp/overview/overview.index.vue"
            ),
        },
        {
          path: "overview/campaign-overview",
          name: "msp-phishing_simulation-overview_campaign-overview",
          component: () =>
            import(
              "@/modules/PhishingSimulations/views/Msp/campaign-details/campaign-details.index.vue"
            ),
        },
        {
          path: "overview/create_campaign",
          name: "msp-phishing_simulation-overview_create-campaign",
          component: () =>
            import(
              "@/modules/PhishingSimulations/views/Msp/create-campaign/create-campaign.index.vue"
            ),
        },
        {
          path: "phishing_campaigns",
          name: "msp-phishing_simulation-phishing_campaigns",
          component: () =>
            import(
              "@/modules/PhishingSimulations/views/Msp/phishing-campaigns/phishing-campaign.index.vue"
            ),
        },
        {
          path: "phishing_campaigns/campaign-overview",
          name: "msp-phishing_simulation-phishing_campaigns-campaign-overview",
          component: () =>
            import(
              "@/modules/PhishingSimulations/views/Msp/campaign-details/campaign-details.index.vue"
            ),
        },
        {
          path: "phishing_campaigns/create_campaign",
          name: "msp-phishing_simulation-phishing_campaigns_create-campaign",
          component: () =>
            import(
              "@/modules/PhishingSimulations/views/Msp/create-campaign/create-campaign.index.vue"
            ),
        },
      ],
    },
  ],
};

export default {};
/* c8 ignore end */
